module.exports = __webpack_public_path__ + "img/prod-permasense-pset210.f09f80c7.png";